/* eslint-disable global-require */
module.exports = [...require('./Drawer/i18n'), ...require('./Display/i18n'), 'artists.artist.filters.m1', 'artists.artist.filters.m2', 'artists.artist.filters.m3'];
